import { render, staticRenderFns } from "./MyAppsList.vue?vue&type=template&id=2bd85602&"
import script from "./MyAppsList.vue?vue&type=script&lang=js&"
export * from "./MyAppsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports